import React, { useId, useLayoutEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { checkboxClass } from '../controls';

/** 메모 선택지 — 지연 없이 설명을 열고, 스크롤 칸 밖의 포털로 띄워 잘림을 피한다. */
export default function NoteOption({ label, description, checked, onChange }) {
  const tooltipId = useId();
  const anchorRef = useRef(null);
  const tooltipRef = useRef(null);
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const [position, setPosition] = useState(null);
  const open = (hovered || focused) && !dismissed;

  useLayoutEffect(() => {
    if (!open) { setPosition(null); return undefined; }
    const anchor = anchorRef.current.getBoundingClientRect();
    const tooltip = tooltipRef.current.getBoundingClientRect();
    const above = anchor.top - tooltip.height >= 8;
    setPosition({
      above,
      left: Math.max(8, Math.min(anchor.left + (anchor.width - tooltip.width) / 2, window.innerWidth - tooltip.width - 8)),
      top: Math.max(8, Math.min(above ? anchor.top - tooltip.height : anchor.bottom, window.innerHeight - tooltip.height - 8)),
    });
    const dismiss = () => setDismissed(true);
    window.addEventListener('resize', dismiss);
    window.addEventListener('scroll', dismiss, true);
    return () => {
      window.removeEventListener('resize', dismiss);
      window.removeEventListener('scroll', dismiss, true);
    };
  }, [open]);

  return (
    <label ref={anchorRef} className="flex cursor-help items-center gap-1.5 text-xs text-gray-600"
      onMouseEnter={() => { setHovered(true); setDismissed(false); }}
      onMouseLeave={() => setHovered(false)}
      onFocus={(e) => { setFocused(e.target.matches(':focus-visible')); setDismissed(false); }}
      onBlur={() => setFocused(false)}
      onKeyDown={(e) => { if (e.key === 'Escape' && open) { e.stopPropagation(); setDismissed(true); } }}>
      <input type="checkbox" className={checkboxClass} checked={checked} onChange={(e) => onChange(e.target.checked)} aria-describedby={open ? tooltipId : undefined} />
      {label}
      {open && createPortal(
        <span ref={tooltipRef} id={tooltipId} role="tooltip" className="fixed w-max max-w-[calc(100vw-1rem)] text-xs"
          style={{ zIndex: 9999985, left: position?.left || 0, top: position?.top || 0, visibility: position ? 'visible' : 'hidden', paddingTop: position?.above === false ? 6 : 0, paddingBottom: position?.above === false ? 0 : 6 }}>
          <span className="block max-w-xs whitespace-normal break-words rounded-lg bg-gray-900 px-3 py-2 leading-relaxed text-white shadow-lg">{description}</span>
        </span>,
        document.body,
      )}
    </label>
  );
}
